export default {
  placeholder: 'Ingrese el nombre del restaurante',
  labels: {
    cant_find_place: '¿No encuentra el lugar en la lista?',
    reset_categories: 'Restablecer categorías de lugar',
  },
};
